import { gql } from '@material-bank/graphql-client'

export const CONSTRUCTOR_USER_CONTEXT_QUERY = gql`
  query ConstructorUserContext {
    constructorUserContext {
      isMember
      userId
      ruleGroupIds
      excludedRuleGroupIds
      isDegraded
    }
  }
`

export type ConstructorUserContext = {
  isMember: boolean
  userId: string | null
  ruleGroupIds: string[] | null
  excludedRuleGroupIds: string[] | null
  isDegraded: boolean
}

export type ConstructorUserContextQueryData = {
  constructorUserContext: ConstructorUserContext
}
